import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { removeFormErrors } from "store/form/actions";

import { useOutsideClickHook } from "utils/outsideClick";
import { useStateSelector } from "utils/field";

import DropDown from "components/Dropdown";
import Dialog, { CloseDialog } from "components/Dialog";
import Button from "components/Button";

import classes from "./style.module.scss";

import Delete from "assets/images/icons/JSX/Delete";
import ResetIcon from "assets/images/icons/Icon-Reset-blue.svg?react";

export default React.memo(({ accessor, type, isSupplemental, change, onResetFlow }) => {
    const dispatch = useDispatch();

    const [menuOpen, toggleMenuOpen] = useState(false);
    const [deleteDialogOpen, toggleDeleteDialog] = useState(false);

    const ref = useOutsideClickHook(() => toggleMenuOpen(false));

    const baseAccessor = accessor.includes("model.modelData.") ? "model.modelData.ventilation" : "fields";

    const wholeHouseVentilators = useStateSelector(`${baseAccessor}.wholeHouseSystems.ventilators`) || {};
    const supplementalVentilators = useStateSelector(`${baseAccessor}.supplementalSystems.ventilators`) || {};

    const handleDelete = () => {
        let ventilationAccessor = isSupplemental
            ? accessor.split(".supplementalSystems")[0]
            : accessor.split(".wholeHouseSystems")[0];

        if (type === "hrv") {
            change(`${ventilationAccessor}.${isSupplemental ? "supplementalSystems" : "wholeHouseSystems"}.hrv`, {});
            dispatch(
                removeFormErrors(
                    `${ventilationAccessor}.${isSupplemental ? "supplementalSystems" : "wholeHouseSystems"}.hrv`
                )
            );
        } else if (type === "dryer") {
            change(`${ventilationAccessor}.supplementalSystems.dryer`, {});
            dispatch(removeFormErrors(`${ventilationAccessor}.supplementalSystems.dryer`));
        } else {
            const filteredVentilators = Object.entries(
                isSupplemental ? supplementalVentilators : wholeHouseVentilators
            ).reduce((acc, [key, value]) => {
                if (key === accessor.split("ventilators.")[1]) {
                    return acc;
                }
                return {
                    ...acc,
                    [key]: value,
                };
            }, {});

            change(
                `${ventilationAccessor}.${isSupplemental ? "supplementalSystems" : "wholeHouseSystems"}.ventilators`,
                filteredVentilators
            );
            dispatch(removeFormErrors(accessor));
        }

        toggleDeleteDialog(false);
    };

    return (
        <div className={classes.actions} ref={ref}>
            <Button
                className={classes.reset}
                type="hollow"
                small
                icon={ResetIcon}
                onClick={(event) => {
                    event.stopPropagation();
                    onResetFlow();
                }}
            >
                Reset flow
            </Button>
            <div className={classes.menu}>
                <div className={classes.dots} onClick={() => toggleMenuOpen(!menuOpen)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <DropDown
                    className={classes.dropDown}
                    open={menuOpen}
                    toggleOpen={toggleMenuOpen}
                    options={[
                        {
                            label: (
                                <span>
                                    <Delete /> Delete
                                </span>
                            ),
                            className: classes.delete,
                            onClick: () => toggleDeleteDialog(true),
                        },
                    ]}
                />
            </div>
            <Dialog open={deleteDialogOpen}>
                <CloseDialog closeActions={() => toggleDeleteDialog(false)} />
                <div className={classes.dialog}>
                    <h3>Are you sure you want to delete this ventilation system?</h3>
                    <div className={classes.footer}>
                        <Button type="hollow" onClick={() => toggleDeleteDialog(false)}>
                            Cancel
                        </Button>
                        <Button onClick={() => handleDelete()} type="red">
                            Delete
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
});
